module.exports = __webpack_public_path__ + "static/media/5-8.58ada526.mp3";